import { Settings } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@mlm/ui';
import { ProfileTab } from '../components/settings/profile-tab';
import { AddressTab } from '../components/settings/address-tab';
import { PasswordTab } from '../components/settings/password-tab';
import { TwoFactorTab } from '../components/settings/two-factor-tab';
import { KycTab } from '../components/settings/kyc-tab';
import { ReferralCodeTab } from '../components/settings/referral-code-tab';
import { PayoutQrTab } from '../components/settings/payout-qr-tab';

const TAB_VALUES = ['profile', 'referral', 'address', 'password', '2fa', 'kyc', 'payout-qr'];

export function SettingsPage() {
  const [params, setParams] = useSearchParams();
  const tab = params.get('tab');
  const activeTab = tab && TAB_VALUES.includes(tab) ? tab : 'profile';
  return (
    <div className="space-y-4">
      <div>
        <h1 className="flex items-center gap-2 text-h1">
          <Settings className="h-6 w-6 text-muted-foreground" /> Settings
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Manage your profile, security, and payout verification.
        </p>
      </div>

      <Tabs
        value={activeTab}
        onValueChange={(v) =>
          setParams(
            (p) => {
              p.set('tab', v);
              return p;
            },
            { replace: true },
          )
        }
        className="w-full"
      >
        <TabsList className="flex flex-wrap h-auto">
          <TabsTrigger value="profile">Profile</TabsTrigger>
          <TabsTrigger value="referral">Referral</TabsTrigger>
          <TabsTrigger value="address">Address</TabsTrigger>
          <TabsTrigger value="password">Password</TabsTrigger>
          <TabsTrigger value="2fa">Two-factor</TabsTrigger>
          <TabsTrigger value="kyc">KYC</TabsTrigger>
          <TabsTrigger value="payout-qr">Payout QR</TabsTrigger>
        </TabsList>
        <TabsContent value="profile">
          <ProfileTab />
        </TabsContent>
        <TabsContent value="referral">
          <ReferralCodeTab />
        </TabsContent>
        <TabsContent value="address">
          <AddressTab />
        </TabsContent>
        <TabsContent value="password">
          <PasswordTab />
        </TabsContent>
        <TabsContent value="2fa">
          <TwoFactorTab />
        </TabsContent>
        <TabsContent value="kyc">
          <KycTab />
        </TabsContent>
        <TabsContent value="payout-qr">
          <PayoutQrTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
